import { Link } from "react-router-dom";
import logo from "@/assets/centralflow-owl-logo.svg";
import { useTranslation } from "react-i18next";

export const Footer = () => {
  const { t } = useTranslation();
  
  return (
    <footer className="bg-[hsl(222,47%,11%)] text-white py-10 sm:py-12 md:py-14">
      <div className="container mx-auto px-4 sm:px-6">
        <div className="grid sm:grid-cols-2 md:grid-cols-4 gap-6 sm:gap-8 mb-6 sm:mb-8">
          {/* Logo & Contact */}
          <div className="text-center sm:text-left">
            <Link to="/" className="flex items-center gap-2 mb-3 justify-center sm:justify-start">
              <img src={logo} alt="Centralflow logo" className="w-6 h-6 sm:w-7 sm:h-7" />
              <span className="font-mokoto text-base sm:text-lg text-white uppercase tracking-wider">CentralFlow</span>
            </Link>
            <p className="text-xs sm:text-sm text-white/70 mb-2">
              {t('footer.contact')}: <a href="mailto:c@centralflow.ai" className="text-[hsl(var(--primary-light))] hover:underline">c@centralflow.ai</a>
            </p>
            <p className="text-xs text-white/60 leading-relaxed mb-4">
              {t('footer.addressLine')}
            </p>
          </div>
          
          {/* Solutions */}
          <div className="text-center sm:text-left">
            <h4 className="font-semibold mb-3 sm:mb-4 text-sm sm:text-base text-white">{t('nav.solutions')}</h4>
            <ul className="space-y-2 text-xs sm:text-sm text-[hsl(215,20%,65%)]">
              <li><Link to="/solutions/hotels" className="hover:text-primary transition-colors">{t('solutionsNav.hotels')}</Link></li>
              <li><Link to="/solutions/serviced-apartments-rentals" className="hover:text-primary transition-colors">{t('solutionsNav.servicedApartments')}</Link></li>
              <li><Link to="/solutions/campsite" className="hover:text-primary transition-colors">{t('solutionsNav.campsite')}</Link></li>
              <li><Link to="/solutions/restaurants-cafes" className="hover:text-primary transition-colors">{t('solutionsNav.restaurantsCafes')}</Link></li>
              <li><Link to="/solutions/bars-nightlife" className="hover:text-primary transition-colors">{t('solutionsNav.barsNightlife')}</Link></li>
              <li><Link to="/solutions/fitness-academies" className="hover:text-primary transition-colors">{t('solutionsNav.fitnessAcademies')}</Link></li>
              <li><Link to="/solutions/spa-wellness" className="hover:text-primary transition-colors">{t('solutionsNav.spaWellness')}</Link></li>
              <li><Link to="/solutions/golf" className="hover:text-primary transition-colors">{t('solutionsNav.golf')}</Link></li>
            </ul>
          </div>
          
          {/* Resources - Reordered: FAQ, Guides, Blog */}
          <div className="text-center sm:text-left">
            <h4 className="font-semibold mb-3 sm:mb-4 text-sm sm:text-base text-white">{t('nav.resources')}</h4>
            <ul className="space-y-2 text-xs sm:text-sm text-[hsl(215,20%,65%)]">
              <li><Link to="/faq" className="hover:text-primary transition-colors">{t('resources.faq')}</Link></li>
              <li><Link to="/guides" className="hover:text-primary transition-colors">{t('resources.guides')}</Link></li>
              <li><Link to="/blog" className="hover:text-primary transition-colors">{t('nav.blog')}</Link></li>
            </ul>
          </div>
          
          
          {/* Legal */}
          <div className="text-center sm:text-left">
            <h4 className="font-semibold mb-3 sm:mb-4 text-sm sm:text-base text-white">{t('footer.legal')}</h4>
            <ul className="space-y-2 text-xs sm:text-sm text-[hsl(215,20%,65%)]">
              <li><Link to="/privacy" className="hover:text-primary transition-colors">{t('footer.privacy')}</Link></li>
              <li><Link to="/terms" className="hover:text-primary transition-colors">{t('footer.terms')}</Link></li>
              <li><Link to="/security" className="hover:text-primary transition-colors">{t('footer.security')}</Link></li>
              <li><Link to="/legal/cookies" className="hover:text-primary transition-colors">{t('footer.cookies')}</Link></li>
            </ul>
          </div>
        </div>
        
        <div className="border-t border-[hsl(224,30%,25%)] pt-6 sm:pt-8 text-center text-xs sm:text-sm text-[hsl(215,20%,55%)]">
          <p>© 2025 CentralFlow. {t('footer.rights')}</p>
        </div>
      </div>
    </footer>
  );
};
